.app {
  width: 100%;
}

.playerAttributesList {
  width: 100%;

  td,
  th {
    padding: 0.5rem;
  }
}

.dataTableContainer {
  margin-top: 1rem;
}
